import React, { createRef } from "react";
import "./review.scss";
import FormTitle from "../components/formTitle/FormTitle";
import Config from "../common/Config";
import apiClient from "../common/apiClient";
import SecondaryButton from "../components/button/SecondaryButton";
import Button from "../components/button/Button";
import Review from "./Review";
import { ClipLoader } from "react-spinners";
import InputTextField from "../components/textField/InputTextField";

class InternalReviewDefinitive extends Review {
  constructor(props) {
    super(props);
    this.targetRef = createRef();

    this.patientInfo1UomMetric = 1;
    this.patientInfo1UomImperial = 2;

    this.customerSuppliedFabricId = 22;
    this.transferAsIsId = 28;
    this.customerSuppliedLockId = 43;
    this.customerSuppliedPlateId = 50;
    this.customerSuppliedValveId = 58;
    this.nomodificationId = 154;

    this.state = {
      isLoaded: false,
      accountNumber: null,
      clinicName: null,
      prosthetistName: null,
      email: null,
      poNumber: null,
      shippingAddress1: null,
      shippingAddress2: null,
      city: null,
      stateName: null,
      zip: null,
      phone: null,
      contactMethodName: null,
      shippingCarrierName: null,
      shippingMethodName: null,
      patientName: null,
      patientId: null,
      patientInfo1UOM: null,
      patientInfo1UOMName: null,
      height: null,
      weight: null,
      isBilateral: null,
      amputationLevel: null,
      kLevel: null,
      footDirection: null,
      estimatedShipDate: null,
      itemsSentIn: null,
      uOM: null,
      mPTToFloor: null,
      pmlWidth: null,
      residualLength: null,
      aboveMPT15cm: null,
      aboveMPT10cm: null,
      aboveMPT5cm: null,
      aboveMPT0cm: null,
      belowMPT5cm: null,
      belowMPT10cm: null,
      belowMPT15cm: null,
      belowMPT20cm: null,
      pml: null,
      ml: null,
      ap: null,
      iTToFloor: null,
      kCToFloor: null,
      tight5cm: null,
      tight10cm: null,
      tight15cm: null,
      tight20cm: null,
      tight25cm: null,
      tight30cm: null,
      loose5cm: null,
      loose10cm: null,
      loose15cm: null,
      loose20cm: null,
      loose25cm: null,
      loose30cm: null,
      limbLength: null,
      femurLength: null,
      flexion: null,
      adduction: null,
      castShippedSeparately: null,
      shapeCreationNotes: null,
      modification: [],
      modificationPercentage: [],
      modificationPly: [],
      trimline: [],
      socketStyle: [],
      brim: [],
      brimOther: [],
      shapeCreation: [],
      lock: [],
      lockType: [],
      valve: [],
      mountingPlate: [],
      material: [],
      foamCarving: [],
      insertMaterial: [],
      AKLynValveOption: [],
      soNumber: null,
      pendingSoNumber: "",
    };
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    try {
      super.loadData();
    

      let fieldInputConfig = {
        headers: {},
        params: {
          fieldNames: [
            "uOM",
            "mPTToFloor",
            "calfToFloor",
            "calfCirc",
            "ankleCirc",
            "socketFinish",
            "otherPRS",
            "socketOption",
            "insertMaterial",
            "lock",
            "lockType",
            "valve",
            "mountingPlate",
            "linerInterface",
            "linerSize",
            "linerProfile",
            "prostheticHeight",
            "prostheticHeightUOM",
            "shorten",
            "extend",
            "iTToFloor",
            "thighToFloor",
            "kCToFloor",
            "thighCirc",
            "kCCirc",
            "socketMaterial",
            "AKLynValveOption",
            "fredsLegsDesignName",
            "additionalRevoFitWindows",
            "revoFit",
            "revoFitEnabled",
            "footType",
            "footMaterial",
            "footImpact",
            "includeFoot",
            "includeLiner",
            "linerQuantity",
            "footShell",
            "modification",
            "modificationPly",
            "modificationPercentage",
            "customerSuppliedPlate",
            "customerSuppliedLock",
            "customerSuppliedValve",
            "customerSuppliedFabric",
          ],
        },
      };

      const config = { headers: {} };
      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
        config.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await apiClient.get("fieldInputs/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;

      
      let footPartNumber = (
        await apiClient.get("footPartNumber/" + this.props.formTypeId,
          config
        )
      ).data;

      let linerPartNumber = (
        await apiClient.get("linerPartNumber/" + this.props.formTypeId,
          config
        )
      ).data;

      const cadFile = (
        await apiClient.get("cadFiles/" + this.props.formTypeId,
          config
        )
      ).data;
      
      const customerSuppliedPlate = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedPlate")?.stringData;
      const customerSuppliedLock = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedLock")?.stringData;
      const customerSuppliedValve = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedValve")?.stringData;
      const customerSuppliedFabric = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedFabric" && fi.stringData != null)?.stringData;

      this.setState({
        uOM: fieldInputs.find((fi) => fi.fieldName === "uOM")?.fieldOptionName,
        mPTToFloor:
          fieldInputs.find((fi) => fi.fieldName === "mPTToFloor")?.numericData ??
          0,
        calfToFloor:
          fieldInputs.find((fi) => fi.fieldName === "calfToFloor")
            .numericData ?? 0,
        calfCirc:
          fieldInputs.find((fi) => fi.fieldName === "calfCirc")?.numericData ??
          0,
        ankleCirc:
          fieldInputs.find((fi) => fi.fieldName === "ankleCirc")?.numericData ??
          0,
        iTToFloor:
          fieldInputs.find((fi) => fi.fieldName === "iTToFloor")?.numericData ??
          0,
        thighToFloor:
          fieldInputs.find((fi) => fi.fieldName === "thighToFloor")?.numericData ?? 
          0,
        kCToFloor:
          fieldInputs.find((fi) => fi.fieldName === "kCToFloor")?.numericData ??
          0,
        thighCirc:
          fieldInputs.find((fi) => fi.fieldName === "thighCirc")?.numericData ??
          0,
        kCCirc:
          fieldInputs.find((fi) => fi.fieldName === "kCCirc")?.numericData ?? 0,
        socketFinish: fieldInputs.filter(
          (fi) => fi.fieldName === "socketFinish"
        ),
        otherPRS: fieldInputs.filter((fi) => fi.fieldName === "otherPRS"),
        socketOption: fieldInputs.filter(
          (fi) => fi.fieldName === "socketOption"
        ),
        insertMaterial: fieldInputs.filter(
          (fi) => fi.fieldName === "insertMaterial"
        ),
        lock: fieldInputs.filter((fi) => fi.fieldName === "lock"),
        lockType: fieldInputs.filter((fi) => fi.fieldName === "lockType"),
        valve: fieldInputs.filter((fi) => fi.fieldName === "valve"),
        mountingPlate: fieldInputs.filter(
          (fi) => fi.fieldName === "mountingPlate"
        ),
        prostheticHeight: fieldInputs.filter(
          (fi) => fi.fieldName === "prostheticHeight"
        ),
        prostheticHeightUOM: fieldInputs.filter(
          (fi) => fi.fieldName === "prostheticHeightUOM"
        ),
        shorten: fieldInputs.filter((fi) => fi.fieldName === "shorten"),
        extend: fieldInputs.filter((fi) => fi.fieldName === "extend"),
        socketMaterial: fieldInputs.filter(
          (fi) => fi.fieldName === "socketMaterial"
        ),
        lynOption: fieldInputs.filter(
          (fi) => fi.fieldName === "AKLynValveOption"
        ),
        fredsLegsDesignName: fieldInputs.filter(
          (fi) => fi.fieldName === "fredsLegsDesignName"
        ),
        revoFit: fieldInputs.filter((fi) => fi.fieldName === "revoFit"),
        revoFitEnabled: fieldInputs.find(
          (fi) => fi.fieldName === "revoFitEnabled"
        )?.booleanData,
        additionalWindowQuantity: fieldInputs.filter(
          (fi) => fi.fieldName === "additionalRevoFitWindows"
        ),
        linerSize: fieldInputs.find((fi) => fi.fieldName === "linerSize")?.fieldOptionName,
        linerProfile: fieldInputs.find((fi) => fi.fieldName === "linerProfile")?.fieldOptionName,
        linerInterface: fieldInputs.find((fi) => fi.fieldName === "linerInterface")?.fieldOptionName,
        linerPartNumber: linerPartNumber,
        footPartNumber: footPartNumber,
        footType: fieldInputs.find((fi) => fi.fieldName === "footType")?.fieldOptionName,
        footMaterial: fieldInputs.find((fi) => fi.fieldName === "footMaterial")?.fieldOptionName,
        footShell: fieldInputs.find((fi) => fi.fieldName === "footShell")?.fieldOptionName,
        footImpact: fieldInputs.find((fi) => fi.fieldName === "footImpact")?.fieldOptionName,
        linerQuantity:
          fieldInputs.find((fi) => fi.fieldName === "linerQuantity")?.numericData ??
          0,
        includeLiner: fieldInputs.find((fi) => fi.fieldName === "includeLiner")?.fieldOptionName === "Yes",
        includeFoot: fieldInputs.find((fi) => fi.fieldName === "includeFoot")?.fieldOptionName === "Yes",

        modification: fieldInputs.find((fi) => fi.fieldName === "modification"),
        modificationPercentage: fieldInputs.filter((fi) => fi.fieldName === "modificationPercentage"),
        modificationPly: fieldInputs.filter((fi) => fi.fieldName === "modificationPly"),
        
        customerSuppliedPlate: (customerSuppliedPlate === "" || customerSuppliedPlate === null) ? "No Value Entered" : customerSuppliedPlate,
        customerSuppliedLock: (customerSuppliedLock === "" || customerSuppliedLock === null) ? "No Value Entered" : customerSuppliedLock,
        customerSuppliedValve: (customerSuppliedValve === "" || customerSuppliedValve === null) ? "No Value Entered" : customerSuppliedValve,
        customerSuppliedFabric: (customerSuppliedFabric === "" || customerSuppliedFabric === null) ? "No Value Entered" : customerSuppliedFabric,

        cadFileName:  cadFile !== null ? cadFile.cadFileName : null,
      });
      await this.loadCart(config);
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }
 
  

  async saveData() {

    let soNumber = { 
      data: this.state.pendingSoNumber,
      uniqueId: this.props.uniqueId 
    };

    this.setState({ soNumber: soNumber.data });

    return apiClient.post("soNumbers/" + this.props.formTypeId, soNumber);
  }

  // Only input field is so number
  onInputChange(e) {
    let newSoData = e.target.value;
    this.setState({
      pendingSoNumber: newSoData,
      hasDataChanged: true,
    });
  }

  formatPhone(phone) {
    if (phone.length === 12) {
      return (
        "(" +
        phone.substr(2, 3) +
        ") " +
        phone.substr(5, 3) +
        "-" +
        phone.substr(8, 4)
      );
    }

    return phone;
  }

  getHeightText(height) {
    if (this.state.patientInfo1UOM === this.patientInfo1UomMetric) {
      return height + " cm";
    } else {
      return Math.floor(height / 12) + "' " + (height % 12) + '"';
    }
  }

  getWeightText(weight) {
    if (this.state.patientInfo1UOM === this.patientInfo1UomMetric) {
      return weight + " kg";
    } else {
      return weight + " lbs";
    }
  }



  formatShipDate(shipDate) {
    if (!shipDate) {
      return "";
    }
    return `${shipDate.month}/${shipDate.day}/${shipDate.year}`;
  }

  setNumericProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] =
      fieldInputs.find((fi) => fi.fieldName === propertyName)?.numericData ?? 0;
  }

  setStringProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = fieldInputs.find(
      (fi) => fi.fieldName === propertyName
    )?.stringData;
  }

  setBooleanProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = this.getYesNo(
      fieldInputs.find((fi) => fi.fieldName === propertyName)?.booleanData
    );
  }

  setArrayProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = fieldInputs.filter(
      (fi) => fi.fieldName === propertyName
    );
  }

  getFlexionLabel() {
    return this.state.flexion >= 0 ? "Flexion" : "Extension";
  }
  getAdductionLabel() {
    return this.state.adduction >= 0 ? "Adduction" : "Abduction";
  }

  displaySONumber() {
    if (this.state.soNumber !== null) {
      return this.simpleDetail("Sales Order #", this.state.soNumber);
    } else {
      return (
        <div className="detail soNumber">
          <div className="detailContentWrapper">
            <div className="content">
              <InputTextField
                label="Sales Order #"
                variant="outlined"
                placeholder="#"
                required={true}
                type="text"
                value={this.state.pendingSoNumber}
                error={false}
                onChange={(e) => this.onInputChange(e)}
              />
              <Button
                text="Save"
                disabled={false}
                onClick={() => this.saveData()}
              />
            </div>
          </div>
        </div>
        
      );
    }
  }


  render() {
    if (!this.state.isLoaded) {
      return (
        <div className="loader">
          <ClipLoader color="#000000" size={40} />
        </div>
      );
    } else {
      return (
        <>
          <div
            className={`internalReviewWrapper reviewWrapper ${
              this.props.isBilateral ? "bilateralWrapper" : ""
            }`}
          >

            <div className="reviews" ref={this.targetRef}>
              <div>
                {!this.props.showOrderSummary && (
                  <div className="summaryName">
                    {this.props.isBilateral && (
                      <div className="bileralName">
                        <h2>{this.props.bilateralName}</h2>
                      </div>
                    )}
                    {!this.props.isBilateral && <h2>{this.props.formName}</h2>}
                  </div>
                )}
                <div className="summaaryHeader">
                  <h2>
                    {this.props.name}
                    {this.props.isBilateral &&
                      " (Order " + this.props.orderNumber + ")"}
                  </h2>
                </div>
              </div>
              <div className="information">

                <div className="subDetail">

                  <div className="detailWrapper">
                    <div className="rightContent">
                      {this.detailsBlock("Order Info",
                          this.simpleDetail("Patient ID", this.state.patientId),
                          this.simpleDetail("PO Number", this.state.poNumber),
                          this.displaySONumber(),
                          this.simpleDetail("Est. Ship Date", this.formatShipDate(this.state.estimatedShipDate)),
                          this.simpleDetail("Facility", this.state.clinicName),
                          this.simpleDetail("", 
                            <>{this.state.shippingAddress1} {this.state.shippingAddress2}, {this.state.city} {this.state.stateName} {this.state.zip}</>)
                      )}

                      {this.detailsBlock("Patient Info",
                        this.simpleDetail("Amputation Level", 
                          (this.props.formTypeId==5) ? "BK" : 
                          (this.props.formTypeId==6) ? "AK" : ""
                        ),
                        this.simpleDetail("Amputation Side", this.state.footDirection),
                        this.simpleDetail("Height", this.state.height),
                        this.simpleDetail("Weight", this.state.weight),
                        this.simpleDetail("K-Level", this.state.kLevel)
                      )}

                      {this.detailsBlock("Adjustments",
                          this.simpleDetail("Prosthetic Height",
                            this.state.prostheticHeight.length > 0 &&
                              this.state.prostheticHeight[0].fieldOptionId !== this.transferAsIsId ? 
                              (this.state.shorten[0]?.numericData !== null ?
                                  <>Shorten by {this.state.shorten[0].numericData} {this.state.prostheticHeightUOM[0].fieldOptionName}</> :
                                  <>Extend by {this.state.extend[0].numericData} {this.state.prostheticHeightUOM[0].fieldOptionName}</>
                              ) : <>Transfer As Is</>
                          ),
                          this.simpleDetail("Volume",
                            this.state.modification?.fieldOptionId !==
                            this.nomodificationId ? (
                            <>
                              {this.makeConditionalModificationFieldOutput(
                                "Percentage",
                                this.state.modificationPercentage,
                                "numericData",
                                true
                              )}
                              {this.makeConditionalModificationFieldOutput(
                                "Ply",
                                this.state.modificationPly,
                                "numericData",
                                true
                              )}
                            </>) : <>No Modification</>
                          )
                      )}

                      <div className="textInputField">
                        {this.detailsBlock("Items sent with Order",
                          (this.state.itemsSentIn !== "" && this.state.itemsSentIn !== null) ?
                            <p>{this.state.itemsSentIn}</p>
                            : <p>"No Value Entered"</p>
                        )}
                      </div>

                      <div className="textInputField">
                      {this.detailsBlock("Notes",
                        !(this.state.notes === null && this.state.shapeCreationNotes === null) ?
                          <><p>{this.state.notes}</p><p>{this.state.shapeCreationNotes}</p></> :
                          <p>No Value Entered</p>
                      )}
                    </div>
                  </div>

                    <div className="leftContent">
                      <div className="summaryName productInformationHeader"><h2>Product Information</h2></div>

                      {this.detailsBlock("Socket Options",
                          this.optionalDetail("Socket Material", this.makeFieldOutput(this.state.socketMaterial)),
                          this.optionalDetail("Socket Finish", 
                            this.makeFieldOutput(this.state.socketFinish),
                            (this.state.socketFinish &&
                              this.state.socketFinish[0].fieldOptionId === this.customerSuppliedFabricId ?
                              <div className="content">
                                <span>Fabric Name</span>
                                <p>
                                  {this.state.customerSuppliedFabric}
                                </p>
                              </div> : <></>)
                            ),
                            this.optionalDetail("Insert Material", this.makeFieldOutput(this.state.insertMaterial)),
                            this.optionalDetail("Plastic Type", this.makeFieldOutput(this.state.material)),
                            this.optionalDetail("Add-Ons", this.makeFieldOutput(this.state.socketOption),
                              (this.state.socketOption &&
                                this.state.socketOption.some(opt => opt.fieldOptionId === 156 && (opt.booleanData ?? true)) ?  //convert nulls to true for backwards compatability with older orders
                                <>
                                <br />
                                <h4>Measurements</h4>
                                {this.props.formTypeId == 5 &&
                                    <>
                                    {this.measurementDetail("MPT To Floor", this.state.mPTToFloor)}
                                    {this.measurementDetail("Calf To Floor", this.state.calfToFloor)}
                                    {this.measurementDetail("Largest Calf", this.state.calfCirc)}
                                    {this.measurementDetail("Largest Ankle", this.state.ankleCirc)}
                                    </>
                                }
                                {this.props.formTypeId == 6 &&
                                    <>
                                    {this.measurementDetail("IT To Floor", this.state.iTToFloorToFloor)}
                                    {this.measurementDetail("Thigh To Floor", this.state.thighToFloor)}
                                    {this.measurementDetail("KC To Floor", this.state.kCToFloor)}
                                    {this.measurementDetail("Calf To Floor", this.state.calfToFloor)}
                            
                                    {this.measurementDetail("Mid Thigh", this.state.thighCirc)}
                                    {this.measurementDetail("KC", this.state.kCCirc)}
                                    {this.measurementDetail("Largest Calf", this.state.calfCirc)}
                                    {this.measurementDetail("Largest Ankle", this.state.ankleCirc)}
                                    </>
                                }
                                </> : <></>
                            )
                      )
                      )}

    
                      {this.detailsBlock("Suspension",
                        this.optionalDetail("Lock", this.makeFieldOutput(this.state.lock),
                            <>{this.state.lock && 
                                this.state.lock[0].fieldOptionId === this.customerSuppliedLockId ?
                                  <div className="content">
                                    <span>Lock Name</span>
                                    <p>
                                      {this.state.customerSuppliedLock}
                                    </p>
                                  </div> : <></>
                            }</>
                        ),
                        this.optionalDetail("Valve", this.makeFieldOutput(this.state.valve),
                            <>{this.state.valve && 
                                this.state.valve[0].fieldOptionId === this.customerSuppliedValveId ?
                                  <div className="content">
                                    <span>Valve Name</span>
                                    <p>
                                      {this.state.customerSuppliedValve}
                                    </p>
                                  </div> : <></>
                            }</>
                        ),
                        this.optionalDetail("Mounting Plate", this.makeFieldOutput(this.state.mountingPlate),
                            <>{this.state.mountingPlate && 
                                this.state.mountingPlate[0].fieldOptionId === this.customerSuppliedPlateId ?
                                  <div className="content">
                                    <span>Material Name</span>
                                    <p>
                                      {this.state.customerSuppliedPlate}
                                    </p>
                                  </div> : <></>
                            }</>
                        ),
                      )}

                      {this.state.revoFitEnabled &&
                        this.detailsBlock("RevoFit®",
                          this.optionalDetail("Options", 
                              this.makeFieldOutput(this.state.revoFit),
                              this.makeConditionalFieldOutput(
                                "Additional Window Quantity",
                                this.state.additionalWindowQuantity,
                                "numericData"
                              )
                          )
                        )
                      }

                      { !this.state.revoFitEnabled &&
                        this.detailsBlock("RevoFit®", this.simpleDetail("Option", "None Selected"))
                      }

                      
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </>
      );
    }
  }

  getIntervalFromCM(cm) {
    if (this.state.uOM === "inches") {
      return `${cm / 2.5} in`;
    } else {
      return `${cm} cm`;
    }
  }

  detailsBlock(title, ...entries) {
    return (<div className="detail">
      <h4>{title}</h4>
      <div className="detailContentWrapper">
        {entries}
      </div>
    </div>);
  }

  simpleDetail(title, content) {
    return (<div className="content">
      <span>{title}</span>
      <p>{content}</p>
    </div>)
  }

  measurementDetail(title, measurement) {
    return this.simpleDetail(title , this.imageMeasurementEntry(measurement));
  }

  optionalDetail(title, content, secondaryContent=null) {
    if(content !== null) {
      return (<>
        <div className="content">
          <span>{title}</span>
          <p>{content}</p>
        </div>
        {secondaryContent}
      </>);
    } else {
      return <></>;
    }
  }
}

  

export default InternalReviewDefinitive;